(() => {
 const outer = document.querySelector('[data-catalog-navigation]');
 if (!outer) return;
 const media = matchMedia('(max-width: 750px)');
 const menus = [...outer.querySelectorAll('.nav-category')];
 function closeAll(except) { menus.forEach(menu => { if (menu !== except) menu.open = false; }); }
 function sync() { outer.open = !media.matches; closeAll(); }
 sync();
 media.addEventListener('change', sync);
 outer.addEventListener('toggle', event => { if (event.target.matches('.nav-category') && event.target.open) closeAll(event.target); }, true);
 outer.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const active = menus.find(menu => menu.open);
  if (active) { active.open = false; active.querySelector('summary').focus(); }
  else if (media.matches && outer.open) { outer.open = false; outer.querySelector('summary').focus(); }
 });
 document.addEventListener('click', event => { if (!outer.contains(event.target)) closeAll(); });
})();
document.querySelectorAll('.popular-reference-row').forEach(row=>{row.addEventListener('toggle',event=>{if(event.target.matches('.popular-reference')&&event.target.open)row.querySelectorAll('.popular-reference').forEach(item=>{if(item!==event.target)item.open=false;});},true);row.addEventListener('keydown',event=>{if(event.key==='Escape'){const opened=row.querySelector('.popular-reference[open]');if(opened){opened.open=false;opened.querySelector('summary').focus();}}});document.addEventListener('click',event=>{if(!row.contains(event.target))row.querySelectorAll('.popular-reference').forEach(item=>item.open=false);});});
